
 export const BisheSkillCourse = `query BisheSkillCourse{
  bisheSkillCourses(sort: "id" ) {
    id
    icontitle
    icon{
      url
    }
    courseList{
      title
      subTitle
      url
      image{
        url
      }
    }
  }
}`